import client from '../_client';
import config from '~/config';
import utils from '~/utils';
import transforms from './transforms';

export const getProducts = (params = {}) => {
    return client.request({
        url: config.api.shop.products,
        method: 'GET',
        params,
        paramsSerializer: utils.network.customParamsSerializer,
        transformRequest: transforms.requests.getProducts,
        transformResponse: transforms.responses.getProducts,
    });
};

export const search = (params = {}) => {
    const query = params.query && params.query !== '' ? params.query : '';
    return client.request({
        url: `${config.api.shop.search}?query=${query}`,
        method: 'GET',
        transformResponse: transforms.responses.search,
    });
};

// Get Product By ID
export const getProduct = (params = {}) => {
    return client.request({
        url: `${config.api.shop.products}${params.id}/`,
        method: 'GET',
        transformResponse: transforms.responses.product,
    });
};

// Get Availability By Url
export const getAvailability = (params) => {
    return client.request({
        url: '',
        baseURL: params.url,
        method: 'GET',
    });
};

export const getFilters = (params = {}) => {
    return client.request({
        url: config.api.shop.filters,
        method: 'GET',
        params,
        transformResponse: transforms.responses.getFilters,
    });
};

// Get Stockrecords By Url
export const getStockrecords = (params) => {
    return client.request({
        url: '',
        baseURL: params.url,
        method: 'GET',
    });
};

// Get Basket Preview
export const getBasket = (params = {}) => {
    return client.request({
        url: config.api.shop.basket.get,
        method: 'GET',
        params,
        transformResponse: transforms.responses.getBasket,
    });
};

export const getPaymentMethods = (params = {}) => {
    return client.request({
        url: config.api.shop.paymentMethods,
        method: 'GET',
        params,
        transformResponse: transforms.responses.getPaymentMethods,
    });
};

export const getAreas = () => {
    return client.request({
        url: config.api.shop.areas,
        method: 'GET',
    });
};

export const getShippingMethods = (params = {}) => {
    return client.request({
        url: config.api.shop.shippingMethods,
        method: 'GET',
        params,
        transformResponse: transforms.responses.getShippingMethods,
    });
};

export const getDeliveryCode = (data = {}) => {
    return client.request({
        url: config.api.shop.getDeliveryCode,
        method: 'POST',
        data,
        transformResponse: transforms.responses.getShippingMethods,
    });
};

export const getShippingPrice = (data = {}) => {
    return client.request({
        url: config.api.shop.shippingMethods + '?basket_key=cart',
        method: 'POST',
        headers: {
            'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
        },
        data,
        transformRequest: transforms.requests.getShippingPrice,
        transformResponse: transforms.responses.getShippingPrice,
    });
};

export const getShippingCityCdekCode = (data = {}) => {
    return client.request({
        url: config.api.shop.getDeliveryCode,
        method: 'POST',
        headers: {
            'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
        },
        data,
        transformRequest: transforms.requests.getShippingCityCdekCode,
        transformResponse: transforms.responses.getShippingCityCdekCode,
    });
};

export const getStores = () => {
    return client.request({
        url: config.api.shop.stores,
        method: 'GET',
    });
};

export const getOrders = (params = {}) => {
    return client.request({
        url: config.api.shop.cabinet.orders,
        method: 'GET',
        params,
        transformRequest: transforms.requests.getOrders,
        transformResponse: transforms.responses.getOrders,
    });
};

export const getOrdersItem = ({ id, ...params }) => {
    return client.request({
        url: config.api.shop.cabinet.orders + id + '/',
        method: 'GET',
        params,
        transformResponse: transforms.responses.getOrdersItem,
    });
};

export const getOrderGiftCard = ({ url, ...params }) => {
    return client.request({
        url,
        method: 'GET',
        params,
        transformResponse: transforms.responses.getOrderGiftCard,
    });
};

export const addToCart = (data = {}) => {
    return client.request({
        url: config.api.shop.basket.add,
        method: 'POST',
        headers: {
            'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
        },
        data,
        transformResponse: transforms.responses.addToCart,
    });
};

export const removeLine = (data = {}) => {
    return client.request({
        url: data.url,
        baseURL: '',
        method: 'DELETE',
        headers: {
            'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
        },
        data,
    });
};

// Update product quantity
export const updateLine = (data = {}) => {
    return client.request({
        url: data.url,
        baseURL: '',
        method: 'PUT',
        headers: {
            'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
        },
        data,
    });
};

export const addToFitting = (params = {}) => {
    const data = {
        ...params,
        basket_key: 'fitting',
    };
    return client.request({
        url: config.api.shop.basket.add,
        method: 'POST',
        headers: {
            'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
        },
        data,
    });
};

export const checkout = (params = {}) => {
    const data = {
        ...params,
    };
    return client.request({
        url: config.api.shop.checkout,
        method: 'POST',
        headers: {
            'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
        },
        data,
    });
};

export const applyPromocode = (params = {}) => {
    const data = {
        basket_key: 'cart',
        ...params,
    };
    return client.request({
        url: config.api.shop.promocode.apply,
        method: 'POST',
        headers: {
            'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
        },
        data,
    });
};

export const removePromocode = (params = {}) => {
    const data = {
        basket_key: 'cart',
        ...params,
    };
    return client.request({
        url: config.api.shop.promocode.remove,
        method: 'POST',
        headers: {
            'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
        },
        data,
    });
};

export const getCertificates = (params = {}) => {
    return client.request({
        url: params.url,
        method: 'GET',
        transformResponse: transforms.responses.getProducts,
    });
};

export const getLenses = (params = {}) => {
    return client.request({
        url: config.api.shop.lenses.list,
        params,
        method: 'GET',
        transformResponse: transforms.responses.getLenses,
    });
};

export const uploadPrescription = (data = {}) => {
    return client.request({
        headers: {
            'enctype': 'multipart/form-data',
            'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
        },
        url: config.api.shop.prescription,
        data,
        method: 'POST',
    });
};
